import React from 'react'
import {
  Box,
  Grid,
} from '@material-ui/core'
import { Stack, Checkbox, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { TimePicker } from './form/DateTimePicker'
import { LocationSelector } from './form/LocationSelector'


export const GalleryLocationFormField = ({
  control,
  classes,
  formProps,
  selectedGallery
}) => {

  const labelStyling = {
    width: 130,
    fontWeight: 600,
    fontSize: 12,
    color: '#606060',
    display: 'flex',
    alignItems: 'center'
  }

    const inputStyling = {
    padding: '0px 10px',
    background: '#ebebeb',
    width: 253,
    height: 25,
    fontWeight: 400,
    fontSize: 12,
      color: '#606060',
      '& div':{
        borderBottom: 'none'
      }
    }
  
  return (
    <Grid item xs={ 12 }>
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <Typography sx={labelStyling}>
          Location:
        </Typography>
        <Typography sx={inputStyling}>
          <LocationSelector
            formProps={formProps}
            currentLocation={{
              lat: selectedGallery?.lat,
              lng: selectedGallery?.lng,
            }}
          />
        </Typography>
      </Box>
    </Grid>
  )
}
